const Configdata = {
    name: 'siikaa pro',
  /* srvurl:'https://apiserver.gostepsup.com' */
      /*      srvurl: 'http://127.0.0.1:5000',  */
  /* srvurl: 'http://localhost:5000', */
   /*  srvurl: 'https://server.citihome.co.in:8001', */
  srvurl: 'https://204.12.203.85:8001', 
   pfppath: '/ind/'
   

}

export default Configdata;
